import script from "./DefaultView.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultView.vue?vue&type=script&setup=true&lang=js"

import "./DefaultView.vue?vue&type=style&index=0&id=535fc812&lang=css"

const __exports__ = script;

export default __exports__